module.exports = __webpack_public_path__ + "img/sc.03a5401b.svg";